export default{
    "warning.versionOverlapping" : "A new version of the app was released. You will be redirected to the newer version.",
    "warning.418"                : "A new version is available",
    "warning.418.info"           : "The app will refresh in 5 seconds",
}